import React from "react";

import { ErrorAlert, SuccessAlert } from ".";
import { useAlerts } from "./AlertProvider";

export { Alerts };

function Alerts() {
  const { alert } = useAlerts();

  return (
    <>
      {alert?.severity === "success" ? (
        <SuccessAlert {...alert} />
      ) : alert?.severity === "error" ? (
        <ErrorAlert {...alert} />
      ) : null}
    </>
  );
}
